import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  can,
} from "../../components/CustomComponent.js";
import { TYPE_ICONS, TYPE_GRADS } from "../../components/asset_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_type.css";

/* ============================================================================
 * จัดการทรัพย์ › ประเภททรัพย์  (/ad/property-types)
 *
 * ข้อมูล master ตั้งต้นของระบบ — ประเภทที่เปิดใช้งานที่นี่คือรายการที่จะไปโผล่ใน
 * ตัวกรองหน้ารวมทรัพย์ ฟอร์มเพิ่ม/แก้ไขทรัพย์ รายงาน และเว็บหน้าบ้าน
 * หน้านี้จึงคุมแค่ของที่จำเป็นจริง ๆ : ชื่อ ไทย/อังกฤษ รหัสอ้างอิง KEY คำอธิบาย
 * ลำดับการแสดงผล และสถานะเปิด/ปิด
 *
 * KEY คือคำนำหน้ารหัสทรัพย์ที่ระบบออกให้ตอนเพิ่มทรัพย์ (SCD-2608-00001 = KEY-ปีเดือน-เลขรัน)
 * ห้ามซ้ำกับประเภทอื่น เพราะเลขรันเดินแยกตาม KEY และเดือน
 *
 * รายการ master มีไม่มาก และต้องเห็นลำดับทั้งชุดพร้อมกันเพื่อจัดเรียงขึ้น-ลง
 * จึงแสดงเป็นตารางเดียวจบ ไม่มีการ์ดสรุป ไม่มีตัวกรอง และไม่แบ่งหน้า
 *
 * ต่อกับ API แล้ว :
 *   GET    admin/asset-categories          (Get — page: 0 = เอาทั้งหมด)
 *   POST   admin/asset-categories          (Save — สร้าง)
 *   PUT    admin/asset-categories/:uid     (Save — แก้ไข / ToggleActive)
 *   PUT    admin/asset-categories/:uid/move (Move — สลับลำดับกับรายการข้างเคียง)
 *   DELETE admin/asset-categories/:uid     (Delete)
 * ========================================================================== */

const EMPTY_FORM = {
  name_th: "",
  name_en: "",
  code: "",
  prefix: "",
  icon: TYPE_ICONS[0],
  grad: TYPE_GRADS[0],
  description: "",
  is_active: true,
};

/* ---------------------------------------------------------------- ตัวช่วย */
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");
const num = (value) => Number(value || 0).toLocaleString("en-US");

/* ชื่อที่แสดง — ตามภาษาที่ผู้ใช้เลือกอยู่ ถ้าอีกภาษายังไม่กรอกให้ใช้ภาษาไทยแทน */
const displayName = (item) => (isTh() ? item.name_th : item.name_en || item.name_th);
const secondName = (item) => (isTh() ? item.name_en : item.name_th);

/* รหัสอ้างอิงต้องเป็น a-z 0-9 และ _ เท่านั้น เพราะถูกเก็บเป็นค่าใน record ทรัพย์ */
const CODE_PATTERN = /^[a-z][a-z0-9_]*$/;
const toCode = (value) => String(value).toLowerCase().replace(/[^a-z0-9_]/g, "");

/* KEY ที่ถูกเอาไปต่อเป็นคำนำหน้ารหัสทรัพย์ (SCD-2608-00001) — A-Z 0-9 เท่านั้น */
const PREFIX_PATTERN = /^[A-Z][A-Z0-9]*$/;
const toPrefix = (value) => String(value).toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);

/* ปี/เดือนปัจจุบันในรูปแบบ YYMM — ใช้ประกอบรหัสตัวอย่างให้เห็นหน้าตาจริงของรหัสที่จะได้ */
const yymm = () => {
  const now = new Date();
  return `${String(now.getFullYear()).slice(-2)}${String(now.getMonth() + 1).padStart(2, "0")}`;
};

/* รหัสทรัพย์ตัวอย่างของประเภทนั้น ๆ : KEY ต่อด้วยปี/เดือน ต่อด้วยเลขรัน 5 หลัก */
const sampleCode = (prefix) => `${toPrefix(prefix) || "KEY"}-${yymm()}-00001`;

export default class PropertyTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],

      modal_form: false,
      edit_uid: "", // ว่าง = โหมดเพิ่มประเภทใหม่
      form: { ...EMPTY_FORM },
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  /* --------------------------------------------------- ดึงรายการประเภททรัพย์ */
  Get = async () => {
    loading(true);
    const result = await GET("admin/asset-categories", { page: 0 }); // ดึงทั้งหมด ไม่แบ่งหน้า
    loading(false);

    if (!result?.status) return;

    this.setState({ items: result.data || [] });
  };

  /* เรียงตามลำดับที่ตั้งไว้เสมอ — ลำดับนี้คือลำดับที่จะไปแสดงในตัวกรองทรัพย์และฟอร์มลงประกาศ */
  ordered = () => [...this.state.items].sort((a, b) => a.sort - b.sort);

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* --------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ไข */
  OpenCreate = () =>
    this.setState({
      modal_form: true,
      edit_uid: "",
      form: { ...EMPTY_FORM },
    });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      form: {
        name_th: item.name_th || "",
        name_en: item.name_en || "",
        code: item.code || "",
        prefix: item.prefix || "",
        icon: item.icon || TYPE_ICONS[0],
        grad: item.grad || TYPE_GRADS[0],
        description: item.description || "",
        is_active: !!item.is_active,
      },
    });

  CloseForm = () => this.setState({ modal_form: false });

  /* ------------------------------------------------------------ บันทึกข้อมูล */
  Save = async () => {
    const { form, edit_uid, items } = this.state;
    const code = toCode(form.code);
    const prefix = toPrefix(form.prefix);

    if (!form.name_th.trim()) return alert("", "warning", t("warning"), t("ptype_verify_name_th"));
    if (!form.name_en.trim()) return alert("", "warning", t("warning"), t("ptype_verify_name_en"));
    if (!code) return alert("", "warning", t("warning"), t("ptype_verify_code"));
    if (!CODE_PATTERN.test(code)) return alert("", "warning", t("warning"), t("ptype_verify_code_format"));
    if (items.some((item) => item.code === code && item.uid !== edit_uid))
      return alert("", "warning", t("warning"), t("ptype_verify_code_duplicate"));
    if (!prefix) return alert("", "warning", t("warning"), t("ptype_verify_prefix"));
    if (!PREFIX_PATTERN.test(prefix)) return alert("", "warning", t("warning"), t("ptype_verify_prefix_format"));
    // KEY ซ้ำกัน = สองประเภทแชร์เลขรันชุดเดียวกัน ดูจากรหัสทรัพย์แล้วแยกประเภทไม่ออก
    if (items.some((item) => item.prefix === prefix && item.uid !== edit_uid))
      return alert("", "warning", t("warning"), t("ptype_verify_prefix_duplicate"));

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    const body = {
      name_th: form.name_th.trim(),
      name_en: form.name_en.trim(),
      code,
      prefix,
      icon: form.icon,
      grad: form.grad,
      description: form.description.trim(),
      is_active: form.is_active,
    };

    loading(true);
    const result = !edit_uid
      ? await POST("admin/asset-categories", body)
      : await PUT("admin/asset-categories/" + edit_uid, body);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false });
    await this.Get();
    alert("", "success", t("success"), edit_uid ? t("save_done") : t("ptype_add_done"));
  };

  /* -------------------------------------------------------- เปิด/ปิดใช้งาน */
  ToggleActive = async (item) => {
    const next = !item.is_active;
    const detail = next ? t("ptype_enable_confirm") : t("ptype_disable_confirm");
    if (!(await alert("", "info", next ? t("ptype_enable") : t("ptype_disable"), `${detail}\n${displayName(item)}`, t("confirm"), t("cancel"))))
      return;

    loading(true);
    const result = await PUT("admin/asset-categories/" + item.uid, { is_active: next });
    loading(false);

    if (!result?.status) return;

    await this.Get();
    alert("", "success", t("success"), next ? t("ptype_enable_done") : t("ptype_disable_done"));
  };

  /* ---------------------------------------------------------- สลับลำดับแสดงผล */
  /* backend สลับ sort กับรายการที่อยู่ติดกันให้ใน transaction เดียว
     ยิงครั้งเดียวจบ ไม่เกิดจังหวะที่ลำดับซ้ำกันระหว่างทาง */
  Move = async (item, step) => {
    const result = await PUT("admin/asset-categories/" + item.uid + "/move", {
      direction: step < 0 ? "up" : "down",
    });
    if (!result?.status) return;

    await this.Get();
  };

  /* ------------------------------------------------------------------- ลบ */
  Delete = async (item) => {
    if (!(await alert("", "warning", t("delete_item"), `${t("ptype_delete_desc")}\n${displayName(item)}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE("admin/asset-categories/" + item.uid, null);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false });
    await this.Get();
    alert("", "success", t("success"), t("delete_done"));
  };

  /* ปุ่มจัดการรายประเภท — ซ่อนตามสิทธิ์ ผู้ที่ดูได้อย่างเดียวจะไม่เห็นปุ่ม */
  renderActions = (item) => (
    <div className="d-flex gap-2">
      {can("asset-categories.update") && (
        <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
          {""}
        </button>
      )}
      {can("asset-categories.delete") && (
        <button
          type="button"
          className="prop-iconbtn icon"
          style={{ borderColor: "#fecaca", color: "#b91c1c" }}
          title={t("delete")}
          onClick={() => this.Delete(item)}
        >
          {""}
        </button>
      )}
    </div>
  );

  /* สวิตช์เปิด/ปิดใช้งาน — เป็นการแก้ข้อมูล ดูอย่างเดียวจะเห็นเป็นป้ายสถานะแทน
     จะได้ไม่กดแล้วไม่มีอะไรเกิดขึ้น */
  renderSwitch = (item) =>
    !can("asset-categories.update") ? (
      <span className={`ppl-pill ${item.is_active ? "ppl-pill--on" : "ppl-pill--ghost"}`}>
        {item.is_active ? t("active") : t("inactive")}
      </span>
    ) : (
      <label className="ppl-switch" title={item.is_active ? t("ptype_disable") : t("ptype_enable")}>
        <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
        <span className="ppl-switch__track" />
      </label>
    );

  /* ==================================================== render : ตารางรายการ */
  renderTable = () => {
    const list = this.ordered();
    const active = this.state.items.filter((item) => item.is_active).length;

    return (
      <div className="prop-card prop-in">
        {/* หัวกล่อง — สรุปจำนวนสั้น ๆ พอให้เห็นภาพรวมโดยไม่ต้องมีการ์ดตัวเลขชุดใหญ่ */}
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("ptype_list_title")}
          </span>
          <div className="d-flex align-items-center gap-2">
            <span className="ppl-pill ppl-pill--ghost">
              {num(list.length)} {t("ptype_types_unit")}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {num(active)} {t("active")}
            </span>
          </div>
        </div>

        <div className="table-responsive">
          <table className="ppl-table" style={{ minWidth: "1020px" }}>
            <thead>
              <tr>
                <th style={{ width: "96px" }}>{t("ptype_sort")}</th>
                <th style={{ width: "262px" }}>{t("ptype_col_name")}</th>
                <th style={{ width: "168px" }}>{t("ptype_prefix")}</th>
                <th>{t("description")}</th>
                <th style={{ width: "132px" }}>{t("updated")}</th>
                <th className="text-center" style={{ width: "104px" }}>
                  {t("status")}
                </th>
                <th className="text-center" style={{ width: "112px" }}>
                  {t("actions")}
                </th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr key={item.uid} className={item.is_active ? "" : "is-off"}>
                  {/* ลำดับ + ปุ่มเลื่อนขึ้น-ลง */}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <span className="pty-rank">{item.sort}</span>
                      {/* สลับลำดับ = แก้ข้อมูล จึงโชว์เฉพาะคนที่แก้ไขได้ */}
                      {can("asset-categories.update") && (
                        <div className="pty-order">
                          <button
                            type="button"
                            className="pty-order__btn icon"
                            title={t("ptype_move_up")}
                            disabled={index === 0}
                            onClick={() => this.Move(item, -1)}
                          >
                            {"\uf062"}
                          </button>
                          <button
                            type="button"
                            className="pty-order__btn icon"
                            title={t("ptype_move_down")}
                            disabled={index === list.length - 1}
                            onClick={() => this.Move(item, 1)}
                          >
                            {"\uf063"}
                          </button>
                        </div>
                      )}
                    </div>
                  </td>

                  {/* ชื่อ + รหัสอ้างอิง */}
                  <td>
                    <div className="d-flex align-items-center gap-3">
                      <div className="pty-tile icon" style={{ background: item.grad }}>
                        {item.icon}
                      </div>
                      <div className="min-w-0">
                        <div className="ppl-name text-truncate">{displayName(item)}</div>
                        <div className="ppl-sub d-flex align-items-center gap-2">
                          <span className="pty-code">{item.code}</span>
                          <span className="text-truncate">{secondName(item)}</span>
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* KEY + ตัวอย่างรหัสทรัพย์ที่ประเภทนี้จะได้ */}
                  <td>
                    <span className="pty-code">{item.prefix || "-"}</span>
                    <div className="ppl-sub mt-1">{item.prefix ? sampleCode(item.prefix) : t("ptype_prefix_empty")}</div>
                  </td>

                  {/* คำอธิบาย */}
                  <td>
                    <div className={`pty-desc ${item.description ? "" : "text-secondary"}`}>
                      {item.description || t("ptype_no_description")}
                    </div>
                  </td>

                  {/* แก้ไขล่าสุด */}
                  <td className="text-secondary text-12">{format_date(item.updated_at, "dd mmm yyyy", locale())}</td>

                  {/* สถานะ */}
                  <td className="text-center">
                    {this.renderSwitch(item)}
                    <div className={`ppl-sub mt-1 fw-bold ${item.is_active ? "text-success" : ""}`}>
                      {item.is_active ? t("active") : t("inactive")}
                    </div>
                  </td>

                  {/* จัดการ */}
                  <td>
                    <div className="d-flex justify-content-center">{this.renderActions(item)}</div>
                  </td>
                </tr>
              ))}

              {!list.length && (
                <tr>
                  <td colSpan={7}>
                    <div className="prop-empty">
                      <div className="prop-empty__icon icon">{"\uf015"}</div>
                      <div className="fw-bold text-dark mb-1">{t("ptype_empty_title")}</div>
                      <div className="text-12">{t("ptype_empty_desc")}</div>
                      {can("asset-categories.create") && (
                        <button type="button" className="prop-btn prop-btn--sm mt-3" onClick={this.OpenCreate}>
                          <span className="icon text-12">{"\uf067"}</span>
                          {t("ptype_add")}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  /* ============================================ render : modal เพิ่ม/แก้ไข */
  renderFormModal = () => {
    const { modal_form, edit_uid, form } = this.state;

    return (
      <Modal
        size="lg"
        show={modal_form}
        onHide={this.CloseForm}
        centered
        contentClassName="border-0 rounded-4 overflow-visible shadow-lg"
      >
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("ptype_edit") : t("ptype_add")}</h5>
            <div className="text-secondary text-12">{edit_uid ? t("ptype_edit_desc") : t("ptype_add_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          {/* ตัวอย่างการ์ด — เห็นผลทันทีตอนแก้ชื่อ ไอคอน หรือสี */}
          <div className="pty-preview mb-4" style={{ background: form.grad }}>
            <div className="pty-preview__icon icon">{form.icon}</div>
            <div className="min-w-0">
              <div className="pty-card__name text-truncate">{form.name_th || t("ptype_preview_name")}</div>
              <div className="pty-card__sub text-truncate">{form.name_en || t("ptype_preview_name_en")}</div>
              <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
                <span className="pty-code">{toCode(form.code) || "code"}</span>
                {/* หน้าตารหัสทรัพย์จริงที่ประเภทนี้จะได้ — เห็นผลทันทีตอนพิมพ์ KEY */}
                <span className="pty-code">{sampleCode(form.prefix)}</span>
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-6">
              <label className="prop-label">
                {t("ptype_name_th")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("ptype_name_th_placeholder")}
                value={form.name_th}
                onChange={(e) => this.setForm({ name_th: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">
                {t("ptype_name_en")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("ptype_name_en_placeholder")}
                value={form.name_en}
                onChange={(e) => this.setForm({ name_en: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">
                {t("ptype_code")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("ptype_code_placeholder")}
                value={form.code}
                disabled={!!edit_uid}
                onChange={(e) => this.setForm({ code: toCode(e.target.value) })}
              />
              <div className="text-secondary text-10 mt-1">{edit_uid ? t("ptype_code_locked") : t("ptype_code_hint")}</div>
            </div>

            {/* KEY — คำนำหน้ารหัสทรัพย์ของประเภทนี้ แก้ทีหลังได้ ทรัพย์เดิมยังคงรหัสเดิมไว้ */}
            <div className="col-md-6">
              <label className="prop-label">
                {t("ptype_prefix")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("ptype_prefix_placeholder")}
                value={form.prefix}
                maxLength={10}
                onChange={(e) => this.setForm({ prefix: toPrefix(e.target.value) })}
              />
              <div className="text-secondary text-10 mt-1">{t("ptype_prefix_hint")}</div>
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("status")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                  {form.is_active ? t("active") : t("inactive")}
                </span>
              </div>
              <div className="text-secondary text-10">{t("ptype_status_hint")}</div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("description")}</label>
              <textarea
                className="prop-field"
                rows={2}
                style={{ height: "auto", paddingTop: "10px" }}
                placeholder={t("ptype_desc_placeholder")}
                value={form.description}
                onChange={(e) => this.setForm({ description: e.target.value })}
              />
            </div>

            {/* ไอคอน + สีการ์ด — เลือกจากชุดที่เตรียมไว้ ให้หน้าตาทั้งระบบเป็นชุดเดียวกัน */}
            <div className="col-md-7">
              <label className="prop-label">{t("ptype_icon")}</label>
              <div className="pty-picker">
                {TYPE_ICONS.map((icon) => (
                  <button
                    key={icon}
                    type="button"
                    className={`pty-picker__icon icon ${form.icon === icon ? "is-on" : ""}`}
                    onClick={() => this.setForm({ icon })}
                  >
                    {icon}
                  </button>
                ))}
              </div>
            </div>

            <div className="col-md-5">
              <label className="prop-label">{t("ptype_color")}</label>
              <div className="pty-picker">
                {TYPE_GRADS.map((grad) => (
                  <button
                    key={grad}
                    type="button"
                    className={`pty-picker__grad ${form.grad === grad ? "is-on" : ""}`}
                    style={{ background: grad }}
                    onClick={() => this.setForm({ grad })}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="ppl-note mt-4">
            <span className="icon">{""}</span>
            <div>{t("ptype_master_hint")}</div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.Save}>
            <span className="icon text-12">{""}</span>
            {t("save")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          {/* หัวข้อหน้า */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("property_categories")}</h3>
              <div className="text-secondary text-14">{t("ptype_page_desc")}</div>
            </div>
            {can("asset-categories.create") && (
              <button type="button" className="prop-btn" onClick={this.OpenCreate}>
                <span className="icon text-14">{""}</span>
                {t("ptype_add")}
              </button>
            )}
          </div>

          {this.renderTable()}
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}
